module.exports = __webpack_public_path__ + "cb40f71fe3abe35312c24f0048674b36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/storyhead/imgs/scrollDown.svg
// module id = 251
// module chunks = 0